import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { CompanyUsersApiService } from '@ninety/mobile/platform/api';

import { appActions } from '../../app/app.actions';

import { CompanyUsersStateActions } from './company-users-state.actions';
import { mapCompanyUserToCompanyUserList } from './company-users-state.model';

@Injectable()
export class CompanyUsersStateEffects {
  private action$ = inject(Actions);
  private companyUsersApi = inject(CompanyUsersApiService);

  logInSuccess_fetch$ = createEffect(() =>
    this.action$.pipe(
      ofType(appActions.initGlobalState),
      map(() => CompanyUsersStateActions.fetch())
    )
  );

  fetch$ = createEffect(() =>
    this.action$.pipe(
      ofType(CompanyUsersStateActions.fetch),
      switchMap(() =>
        this.companyUsersApi.getCompanyUsers().pipe(
          map(companyUsers => CompanyUsersStateActions.fetchSuccess({ companyUsers })),
          catchError((error: unknown) => of(CompanyUsersStateActions.fetchError({ error })))
        )
      )
    )
  );

  fetchSuccess_SetCompanyUsers$ = createEffect(() =>
    this.action$.pipe(
      ofType(CompanyUsersStateActions.fetchSuccess),
      map(({ companyUsers }) => mapCompanyUserToCompanyUserList(companyUsers)),
      map(companyUsers => CompanyUsersStateActions.setCompanyUsers({ companyUsers }))
    )
  );

  afterCompanyUsersLoaded$ = createEffect(() =>
    this.action$.pipe(
      ofType(CompanyUsersStateActions.setCompanyUsers),
      map(() => CompanyUsersStateActions.afterCompanyUsersLoaded())
    )
  );
}
